/** Stable, label-derived test id so the proposal-wizard fields are addressable
 *  in E2E without per-field wiring, e.g. "POC investment (USD)" → "pf-poc-investment-usd".
 *  Lives in its own module so the component files stay fast-refresh-clean. */
export function fieldTestId(label: string): string {
  return 'pf-' + label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
}
